export default {
      id: "plus-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#plus",
      toString: function () {
        return this.url;
      }
    }